import { render, staticRenderFns } from "./BandejaComponentePaginador.vue?vue&type=template&id=212adf1e&scoped=true"
import script from "./BandejaComponentePaginador.vue?vue&type=script&lang=js"
export * from "./BandejaComponentePaginador.vue?vue&type=script&lang=js"
import style0 from "./BandejaComponentePaginador.vue?vue&type=style&index=0&id=212adf1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212adf1e",
  null
  
)

export default component.exports